<template>
    <v-row>
        <v-col cols="12">
            <v-row class="mx-1">
                <v-col md="6" sm="9" cols="12">
                    <v-text-field
                        :label="$t('eventWaiver.filter_event')"
                        :hint="$t('eventWaiver.hint_filter_event')"
                        persistent-hint
                        outlined dense
                        v-model="searchEvent"
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    {{ $t("eventWaiver.text_step_2_1") }}
                </v-col>
                <v-col cols="12">
                    <v-data-table
                        v-model="selectedEvents"
                        :headers="eventsHeader"
                        :items="eventsItemsFilter"
                        :options="{itemsPerPage:-1}"
                        class="elevation-1"
                        :single-select="singleSelect"
                        item-key="eventId"
                        show-select
                        dense
                        :footer-props="{
                            'items-per-page-text': $t('dataTable.rowsPerPageText'),
                            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                        }"
                        :no-data-text="$t('dataTable.noDataText')"
                        :headerProps="{
                            'sort-by-text': $t('dataTable.sortByText')
                        }"
                    >
                        <template v-slot:item.eventDate="{ item }">
                            {{ item.eventDate | formatDateForHumans(false) }}
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
            <v-row class="ml-1 mr-1">
                <v-col md="6" class="text-left">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="$emit('backStep')"
                    >{{ $t("common.prev") }}</v-btn>
                </v-col>
                <v-col md="6" class="text-right">
                    <v-btn
                        :color="`${buttonColor}`"
                        class="btn text--white"
                        @click="next"
                    >{{ $t("common.next") }}</v-btn>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import { 
    VRow, VCol, VBtn, VDataTable, VTextField
} from 'vuetify/lib';
import EventWaiverService from "@/services/EventWaiverService";
import { mapGetters } from "vuex";

export default {
    components: {
        VRow, VCol, VBtn, VDataTable, VTextField
    },
    props: {
        peoplesSelected: Array
    },
    data() {
        return {
            buttonColor: "#000",
            eventsItems: [],
            singleSelect: false,
            selectedEvents: [],
            searchEvent: ""
        }
    },
    computed: {
        ...mapGetters({
            env: "env"
        }),
        eventsHeader() {
            let header = [
                { text: this.$t("eventWaiver.event_id"), value: "eventId" },
                { text: this.$t("eventWaiver.promoterName"), value: "promoterName" },
                { text: this.$t("eventWaiver.eventName"), value: "eventName" },
                { text: this.$t("eventWaiver.eventDate"), value: "eventDate",class:'eventDate' }
            ];
            return header;
        },        
        eventsItemsFilter()
        {
            const eventsItems = this.defaultPromoter ? this.eventsItems.filter(e => e.promoterTblId == this.defaultPromoter) : this.eventsItems;

            if(this.searchEvent && eventsItems) {
                return eventsItems.filter(event => {
                    return (
                        event.eventId.toString().toLowerCase().includes(this.searchEvent.toLowerCase()) || 
                        event.promoterName.toLowerCase().includes(this.searchEvent.toLowerCase()) || 
                        event.eventName.toLowerCase().includes(this.searchEvent.toLowerCase()) ||
                        event.eventDate.toLowerCase().includes(this.searchEvent.toLowerCase())
                    )
                });
            }

            return eventsItems;
        },
        defaultPromoter(){
            return this.env.get('VUE_APP_DEFAULT_PROMOTER');
        }
    },
    created() {
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            EventWaiverService.getEventList().then((resp) => {
                if(resp.data.success) {
                    this.eventsItems = resp.data.message;
                }
            });
        },
        next() {
            if(this.selectedEvents.length == 0) {
                this.$emit('showSnackBar', { msg: this.$tc("eventWaiver.invalid_step_1"), color: "error" });
                return;
            }
            
            this.$emit('nextStep');
        }
    },
    watch: {
        selectedEvents(val) {
            this.$emit("changeEventsList", val);
        }
    }
}
</script>
<style>

</style>